import { Injectable } from '@angular/core';
import { LoggedInUserInfo, LoggedInUserInfoServiceInterface } from '@vendasta/sales-common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInUserInfoService implements LoggedInUserInfoServiceInterface {
  loggedInUserInfo$: Observable<LoggedInUserInfo>;
  hasAccessToAllAccountsInMarket$: Observable<boolean>;
  salesPersonId$: Observable<string>;

  constructor(private readonly appConfigService: AppConfigService) {
    this.loggedInUserInfo$ = this.appConfigService.config$.pipe(
      map((config) => {
        return {
          salespersonId: '',
          isImpersonation: false,
          hasAccessToAllAccountsInMarket: false,
          partnerId: config.partnerId,
          marketId: config.userMarket,
          phoneExtension: '',
          userName: config.userFirstName + ' ' + config.userLastName,
          salesManagerId: config.userEmail,
        };
      }),
    );

    this.hasAccessToAllAccountsInMarket$ = of(true);
    this.salesPersonId$ = of('');
  }

  getPartnerId(): Observable<string> {
    return this.appConfigService.config$.pipe(
      map((config) => {
        return config.partnerId;
      }),
    );
  }

  getMarketId(): Observable<string> {
    return this.appConfigService.config$.pipe(
      map((config) => {
        return config.userMarket;
      }),
    );
  }
}
